import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';


@Injectable({
    providedIn: 'root'
})
export class ReportingCorporateService{

    constructor(
        private http: HttpClient, 
        private _restClientService : RestClientService
        ) 
    {}
    
    
  
    exportDossier(requestId: string): Observable<Blob> {
        
        const downloadUrl = environment.BACKEND_RACINE_URL+`corporate/export-dossier?requestid=${requestId}&exportType=PDF`;
  
        const options = {
          responseType: 'blob' as 'json',
        };
        
        return this.http.get<any>(downloadUrl, options);
    }
  
    exportDossiers(debut: String, fin: String): Observable<Blob> {
        
        const downloadUrl = environment.BACKEND_RACINE_URL+'reporting-corporate/export-dossiers?debut='+debut+'&fin='+fin;
  
        const options = {
          responseType: 'blob' as 'json',
        };
        
        return this.http.get<any>(downloadUrl, options);
    }
  
    
    lettreNotification(requestId: string): Observable<Blob> {
        
        const downloadUrl = environment.BACKEND_RACINE_URL+`corporate/lettre-notification?requestid=${requestId}&exportType=PDF`;
  
        const options = {
          responseType: 'blob' as 'json',
        };
        
        return this.http.get<any>(downloadUrl, options);
    }

    ficheMisEnPlace(requestId: string): Observable<Blob> {
        
        const downloadUrl = environment.BACKEND_RACINE_URL+`corporate/fiche-mise-en-place?requestid=${requestId}&exportType=PDF`;
  
        const options = {
          responseType: 'blob' as 'json',
        };
        
        return this.http.get<any>(downloadUrl, options);
    }
  
  
      
  
}